// tslint:disable

import {get} from 'lodash';
import * as React from 'react';
import {InputField} from '../../components/fields/input.field';
import {Field, FormLib} from '../../components/libs/form.lib';
import {ResourceLoader} from '../../components/libs/resource-loader';
import {DefaultSave} from '../../components/libs/updaters/default-save';
import {Validators} from '../../components/libs/Validators';
import {LoaderComponent} from '../../components/structurals/loader.component';
import {ToggleBoxComponent} from '../../components/structurals/toggle-box.component';
import {TextAreaField} from "../../components/fields/textarea.field";
import {WysiwygField} from "../../components/fields/wysiwyg.field";
import {MediaItemField} from "../../components/fields/media-item.field";
import {DatepickerField} from "../../components/fields/datepicker.field";
import {CheckboxField} from "../../components/fields/checkbox.field";
import {IriField} from "../../components/fields/iri.field";
import {ResourceModal} from "../../components/structurals/resource-modal";
import axios from "axios";
import {Environment} from "../../environment/environment";
import {
    ListActions,
    ListResponsePresenterTable
} from "../../components/structurals/presenters/list-response-presenter-table";
import {ListLib} from "../../components/libs/list.lib";
import {ListResourceLoader} from "../../components/libs/list-resource-loader";
import {Notification} from "../../index";
import * as moment from 'moment';
import {IriPresenter} from "../../components/structurals/presenters/iri-presenter";

const { compose, withStateHandlers } = require("recompose");
const {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker,
    InfoWindow
} = require("react-google-maps");

const MapWithAMakredInfoWindow = compose(
    withStateHandlers(() => ({
        isOpen: false,
    }), {
        onToggleOpen: ({ isOpen = true }) => () => ({
            isOpen: !isOpen,
        })
    }),
    withScriptjs,
    withGoogleMap
)((props: any) =>
    <div>
        {console.log(props.center)}
    <GoogleMap

        defaultZoom={15}
        center={ props.center }

    >
        <Marker
            position={ props.center }
            onClick={props.onToggleOpen}
        >
            {props.isOpen && <InfoWindow onCloseClick={props.onToggleOpen}>
               <div>{props.infoText}</div>
            </InfoWindow>}
        </Marker>
    </GoogleMap>
    </div>
);

export class DefaultEvent extends React.Component<any, any> {

    public state: any = {
        lat: false,
        lng: false,
        eventPlace: false
    }
    private executor: DefaultSave<any> = new DefaultSave<any>(null, this.props);

    public async saveForm(form: FormLib): Promise<any> {
        this.executor.updateForm(form);
        await this.executor.exec();
    }

    handlePlaceCreated(eventPlace: any, form: FormLib) {
        form.fields.place.setValue(get(eventPlace, '@id'));
    }

    async changePlace(field: any, type: any) {
        this.setState({eventPlace: field})
        if (field) {
            var fetched = await axios.get(`${Environment.get('api.base')}${field}`, {withCredentials: true});

            if (fetched.data) {
                this.setState({lat: fetched.data.coordinates.latitude, lng: fetched.data.coordinates.longitude})
            }
        }
    }

    render() {
        return (
            <ResourceLoader entity="event" entityId={this.props.ENTITY_ID} render={(form: FormLib) => <div>
                <div id="page-title">
                    <h2>
                        {this.props.IS_CREATE ? 'Create new event' : 'Edit event'}
                    </h2>
                    <p>Lorem</p>
                </div>
                <LoaderComponent isLoading$={this.executor.loading$}/>
                <div className="row">
                    <div className="col-md-9">
                        <ToggleBoxComponent title="Event details" color="green" alwaysOpen={true}>
                            <div className="row">
                                <div className="col-xs-12">
                                    <InputField
                                        field={form.fields.title}
                                        validators={[
                                            Validators.required('Required')
                                        ]}/>
                                    <TextAreaField
                                        field={form.fields.introduction}
                                        validators={[Validators.required('Required')]}/>
                                    <WysiwygField
                                        title='Description'
                                        field={form.fields.description}
                                    />
                                    <button className="btn btn-success pull-left" onClick={() => this.saveForm(form)}>Save</button>
                                </div>
                            </div>
                        </ToggleBoxComponent>
                        <ToggleBoxComponent title="Place" color="red" alwaysOpen={true}>
                            <div className="row">
                                <div className="col-xs-12">
                                    <IriField
                                        field={form.fields.place}
                                        itemRender={(item: any) => get(item, 'title')}
                                        defaultAll={true}
                                        onChange={(field: Field) => this.changePlace(field, 'event-place')}
                                    />
                                    {this.state.eventPlace &&

                                        <ResourceModal
                                            baseClass="float-left"
                                            entity="event-place"
                                            entityId={this.state.eventPlace.replace('/event-place/', '')}
                                            extClass="btn-xs"
                                            title={<div>Edit place</div>}/>

                                    }
                                    <ResourceModal
                                        baseClass="float-right"
                                        entity="event-place"
                                        entityId="create"
                                        extClass="btn-xs"
                                        btnColor="warning"
                                        onCreateSuccessful={(value: any) => this.handlePlaceCreated(value, form)}
                                        title={<div><i className="fa fa-plus"/> Add new Place</div>}/>
                                    {this.state.lat &&
                                        <div className="clear" style={{paddingTop: "5px"}}>
                                            <div className="divider"/>
                                            <MapWithAMakredInfoWindow
                                                googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyC4R6AN7SmujjPUIGKdyao2Kqitzr1kiRg&v=3.exp&libraries=geometry,drawing,places"
                                                loadingElement={<div style={{ height: `100%` }} />}
                                                containerElement={<div style={{ height: `400px` }} />}
                                                mapElement={<div style={{ height: `100%` }} />}
                                                center={{ lat: this.state.lat, lng: this.state.lng }}
                                                infoText="Hello"
                                            />
                                        </div>
                                    }
                                </div>
                            </div>
                        </ToggleBoxComponent>
                        <ToggleBoxComponent title="Agenda" color="green" defaultClosed={false}>
                            <div className="row">
                                <div className="col-xs-12">

                                    <ListResourceLoader
                                        entity="event-agenda"
                                        forceQuery={{event: this.props.ENTITY_ID, pagination: false, 'order[startDate]': 'ASC'}}
                                        render={(list: ListLib) => <div className="w-100">
                                            <ListResponsePresenterTable
                                                head={() => this.agendaHead()}
                                                row={(item: any, index: number, actions: ListActions) => this.agendaRow(item, index, actions, list)}
                                                items={list.member}/>

                                            <ResourceModal
                                                entity="event-agenda"
                                                entityId="create"
                                                extClass="btn-xs"
                                                config={{event: `/event/${this.props.ENTITY_ID}`}}
                                                onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                                title={<div><i className="fa fa-plus"/> Add new agenda item</div>}/>
                                        </div>}
                                    />



                                    <div className="divider"></div>
                                    <WysiwygField
                                        title='Agenda header'
                                        field={form.fields.agendaHeader}
                                        height={200}
                                    />
                                    <WysiwygField
                                        title='Agenda footer'
                                        field={form.fields.agendaFooter}
                                        height={200}
                                    />
                                </div>
                            </div>
                        </ToggleBoxComponent>

                        <ToggleBoxComponent title="Attendees" color="green" defaultClosed={false}>
                            <div className="row">
                                <div className="col-xs-12">

                                    <ListResourceLoader
                                        entity="attendee"
                                        forceQuery={{event: this.props.ENTITY_ID, pagination: false, 'order[sortNo]':' ASC'}}
                                        render={(list: ListLib) => <div className="w-100">
                                            <ListResponsePresenterTable
                                                head={() => this.attendeeHead()}
                                                row={(item: any, index: number, actions: ListActions) => this.attendeeRow(item, index, actions, list)}
                                                items={list.member}/>

                                            <ResourceModal
                                                entity="attendee"
                                                entityId="create"
                                                extClass="btn-xs"
                                                config={{event: `/event/${this.props.ENTITY_ID}`}}
                                                onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                                title={<div><i className="fa fa-plus"/> Add new attendee</div>}/>
                                        </div>}
                                    />
                                </div>
                            </div>
                        </ToggleBoxComponent>

                        <ToggleBoxComponent title="Contact" color="green" defaultClosed={false}>
                            <div className="row">
                                <div className="col-xs-12">

                                    <ListResourceLoader
                                        entity="event-contact"
                                        forceQuery={{event: this.props.ENTITY_ID, pagination: false, 'order[sortNo]':' ASC'}}
                                        render={(list: ListLib) => <div className="w-100">
                                            <ListResponsePresenterTable
                                                head={() => this.eventContactHead()}
                                                row={(item: any, index: number, actions: ListActions) => this.eventContactRow(item, index, actions, list)}
                                                items={list.member}/>

                                            <ResourceModal
                                                entity="event-contact"
                                                entityId="create"
                                                extClass="btn-xs"
                                                config={{event: `/event/${this.props.ENTITY_ID}`}}
                                                onCreateSuccessful={(value: any) => this.handleCreateAndUpdate(value, list)}
                                                title={<div><i className="fa fa-plus"/> Add new Contact</div>}/>
                                        </div>}
                                    />
                                </div>
                            </div>
                        </ToggleBoxComponent>
                        <ToggleBoxComponent title="Dresscode" color="blue" defaultClosed={true}>
                            <div className="row">
                                <div className="col-md-9">
                                    <WysiwygField
                                        title='Dresscode'
                                        field={form.fields.dressCodeBody}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <MediaItemField
                                        field={form.fields.dressCodeCover}
                                    />
                                </div>
                            </div>
                        </ToggleBoxComponent>

                        <ToggleBoxComponent title="Experiences" color="green" defaultClosed={true}>
                            <div className="row">
                                <div className="col-md-9">
                                    <WysiwygField
                                        title='Experiences'
                                        field={form.fields.experiencesBody}
                                    />
                                </div>
                                <div className="col-md-3">
                                    <MediaItemField
                                        field={form.fields.experiencesCover}
                                    />
                                </div>
                            </div>
                        </ToggleBoxComponent>

                        <ToggleBoxComponent title="Terms" color="red" alwaysOpen={false} defaultClosed={true}>
                            <div className="row">
                                <div className="col-md-12">
                                    <WysiwygField
                                        title='Terms & Conditions'
                                        field={form.fields.termsBody}
                                    />
                                </div>
                            </div>
                        </ToggleBoxComponent>

                        <ToggleBoxComponent title="Mail data" color="green" alwaysOpen={false} defaultClosed={true}>
                            <div className="row">
                                <div className="col-md-12">
                                    <WysiwygField
                                        title='Successful registration mail'
                                        field={form.fields.regSuccessMsg}
                                    />
                                    <WysiwygField
                                        title='Registration mail'
                                        field={form.fields.regMailMsg}
                                    />
                                    <WysiwygField
                                        title='Useful contact message'
                                        field={form.fields.usefulContactMsg}
                                    />
                                </div>
                            </div>
                        </ToggleBoxComponent>
                    </div>
                    <div className="col-md-3">
                        <ToggleBoxComponent title="Images" color="blue" alwaysOpen={true} preIcon={'fa-image'}>
                            <MediaItemField
                                field={form.fields.cover}
                            />
                            <MediaItemField
                                field={form.fields.promoCover}
                            />
                        </ToggleBoxComponent>
                        <ToggleBoxComponent title="Properties" color="blue" alwaysOpen={true} preIcon={'fa-image'}>
                            <IriField
                                field={form.fields.category}
                                itemRender={(item: any) => get(item, 'title')}
                                defaultAll={true}
                            />


                            <DatepickerField field={form.fields.startDate}/>
                            <DatepickerField field={form.fields.endDate}/>
                            <DatepickerField field={form.fields.regStartDate}/>
                            <DatepickerField field={form.fields.regEndDate}/>

                            <CheckboxField
                                field={form.fields.live}
                            />
                            <CheckboxField
                                field={form.fields.featured}
                            />
                        </ToggleBoxComponent>
                    </div>
                </div>

            </div>}/>
        );
    }

    private agendaHead() {
        return <tr>
            <th>Title</th>
            <th>Place</th>
            <th>startDate</th>
            <th>endDate</th>
            <th>Speaker</th>
            <th>Action</th>
        </tr>;
    }

    private agendaRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>
                {get(item, 'title')}
            </td>
            <td>
                {get(item, 'place')}
            </td>
            <td>
                {moment(get(item, 'startDate')).format('DD/MM/Y H:mm')}
            </td>
            <td>
                {moment(get(item, 'endDate')).format('DD/MM/Y H:mm')}
            </td>
            <td>
                <IriPresenter
                    iri={get(item.speaker, '@id')}
                    render={(item: any) => get(item, 'name')}
                />
            </td>
            <td style={{width: "80px"}}>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'event-agenda'}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        config={{event: `/event/${this.props.ENTITY_ID}`}}
                        entityId={item.id || item['@id'].replace('/event/', '')}
                        extClass="btn-sm"
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Remove
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }

    private attendeeHead() {
        return <tr>
            <th>Person</th>
            <th>Guest Type</th>
            <th>Status</th>
            <th>Action</th>
        </tr>;
    }

    private attendeeRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>
                <IriPresenter
                    iri={get(item.personCompany, '@id')}
                    render={(item: any) =>
                        <IriPresenter
                            iri={get(item.person, '@id')}
                            render={(item: any) => `${get(item, 'firstName')} ${get(item, 'surName')}`
                            }
                        />
                    }
                />
            </td>
            <td>
                <IriPresenter
                    iri={get(item.guestType, '@id')}
                    render={(item: any) => get(item, 'title')}
                />
            </td>
            <td>
                {get(item, 'statusText')}
            </td>
            <td style={{width: "80px"}}>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'attendee'}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        config={{event: `/event/${this.props.ENTITY_ID}`}}
                        entityId={item.id || item['@id'].replace('/event/', '')}
                        extClass="btn-sm"
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Remove
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }


    private eventContactHead() {
        return <tr>
            <th>Person</th>
            <th>Type</th>
            <th>Action</th>
        </tr>;
    }


    private eventContactRow(item: any, index: number, actions: ListActions, list: ListLib) {
        return <tr key={index}>
            <td>
                <IriPresenter
                    iri={get(item.personCompany, '@id')}
                    render={(item: any) =>
                        <IriPresenter
                            iri={get(item.person, '@id')}
                            render={(item: any) => `${get(item, 'firstName')} ${get(item, 'surName')}`
                            }
                        />
                    }
                />
            </td>
            <td>
                {/*<IriPresenter
                    iri={get(item.type, '@id')}
                    render={(item: any) => get(item, 'title')}
                />*/}
            </td>
            <td style={{width: "80px"}}>
                <div className="btn-group btn-group-sm resource-modal-fixup">
                    <ResourceModal
                        title={'Edit'}
                        entity={'event-contact'}
                        onUpdateSuccessful={(value: any) => list.refetch()}
                        config={{event: `/event/${this.props.ENTITY_ID}`}}
                        entityId={item.id || item['@id'].replace('/event/', '')}
                        extClass="btn-sm"
                    />
                    <button type="button" className="btn btn-primary dropdown-toggle" data-toggle="dropdown">
                        <span className="sr-only">Toggle Dropdown</span>
                    </button>
                    <ul className="dropdown-menu" role="menu">
                        <li>
                            <a onClick={(event: any) => this.handleDelete(item, list, actions, event)}>
                                Remove
                            </a>
                        </li>
                    </ul>
                </div>
            </td>
        </tr>;
    }
    handleCreateAndUpdate(pc: any, list: ListLib) {
        list.refetch();
    }

    private async handleDelete(item: any, list: ListLib, ListActions: ListActions, event: any) {
        event.preventDefault();
        event.stopPropagation();

        const answer = await Notification.delete();

        if (answer === true) {
            try {
                list.isLoading$.next(true);
                await ListActions.delete(item['@id']);
            } catch (error) {

            } finally {
                list.refetch();
            }
        }

    }
}



// WEBPACK FOOTER //
// ./src/__templates/details/default.event.tsx